import PropTypes from 'prop-types'
import cx from 'classnames'
import { Link } from 'react-router-dom'

import { getExternalInternalUrl, isExternalUrl as checkExternalUrl } from 'utils/url'

import css from './Item.sass'

const Item = (props) => {
  const { link, text, routeMatches, attributes, onClick, isAgent, urlParams } = props
  const to =
    typeof link === 'function'
      ? getExternalInternalUrl(link(isAgent), urlParams)
      : getExternalInternalUrl(link, urlParams)
  const route = typeof routeMatches === 'function' ? routeMatches(isAgent) : routeMatches
  const isExternalUrl = checkExternalUrl(to)
  const linkProps = isExternalUrl ? { href: to } : { to }

  return (
    <div className={css.root}>
      {route && !isExternalUrl && (
        <Link className={css.link} dangerouslySetInnerHTML={{ __html: text }} {...attributes} {...linkProps} />
      )}
      {(!route || isExternalUrl) && to && (
        <a className={cx(css.link)} dangerouslySetInnerHTML={{ __html: text }} href={to} {...attributes} />
      )}
      {!route && !to && (
        <div
          role='button'
          className={css.link}
          onClick={onClick}
          dangerouslySetInnerHTML={{ __html: text }}
          {...attributes}
        />
      )}
    </div>
  )
}

const { string, bool, object, func, oneOfType } = PropTypes

Item.propTypes = {
  routeMatches: oneOfType([bool, func]),
  attributes: object,
  link: oneOfType([string, func]),
  text: string,
  onClick: func,
  isAgent: bool,
  urlParams: object,
}

export default Item
